import { lazyRouteComponent } from '@tanstack/react-router';

export const authPageLoadable = lazyRouteComponent(() =>
  import('../../ui/auth-page').then((m) => ({ default: m.AuthPage })),
);
